import subscriptions from "../../api/subscriptions";
import createReducer from "../../utils/createReducer";
import * as types from "./types";

const initialState = null;

const subscriptionReducer = createReducer(initialState)({
  [types.GET_ALL_SUBSCRIPTIONS]: (state, { subscriptions }) => ({
    ...state,
    subscriptions,
  }),
  [types.GET_SUBSCRIPTED_USERS]: (
    state,
    {
      items,
      filterMode,
      current_page,
      page_count,
      items_per_page,
      total_item_count,
    }
  ) => {
    return {
      ...state,
      items,
      filterMode,
      current_page,
      page_count,
      items_per_page,
      total_item_count,
    };
  },
  [types.DELETE_COMPANY]: ({
    subscriptions: {
      subscriptions,
      companies,
    }
  }, { id }) => {
    return {
      subscriptions: {
        subscriptions: {
          ...subscriptions
        },
        companies: {
          ...companies,
          items: companies.items.filter(el => el.id !== id)
        }
      }
    }
  },
  [types.DELETE_SUBSCRIBER]: (state, { id }) => {
    return {
      ...state,
      items: state.items.filter(el => el.id !== id)
    }
  },
  [types.GET_COMPANY_DETAILS]: (state, { payload }) => ({
    ...state,
    currentCompany: payload,
  }),
});

export default subscriptionReducer;
